// TODO: we may want to merge this and locales.ts into something like l10n.ts

export function getLanguageCodeFromLocale(locale?: string): string | null {
    if (!locale) {
        return null;
    }

    if (locale === 'zh-tw') {
        return 'tw';
    }

    return locale.split('-')[0];
}

export function getCountryCodeFromLocale(locale?: string): string | null {
    if (!locale) {
        return null;
    }

    return locale.split('-')[1];
}
